import React from 'react';
import cn from 'classnames';

import { WidgetContactFormMode } from 'widget/entities/config';

import styles from './SubmissionFormContainer.module.scss';

export type SubmissionFormContainerProps = {
  mode: WidgetContactFormMode;
  children: React.ReactNode;
  className?: string;
};

const SubmissionFormContainer: React.FC<SubmissionFormContainerProps> = ({
  mode,
  children,
  className
}) => {
  return (
    <div
      className={cn(
        styles['submission-form-container'],
        styles[`submission-form-container_${mode}`],
        className
      )}
    >
      {children}
    </div>
  );
};

export default React.memo(SubmissionFormContainer);
